<template>
  <div class="foot">
    <div class="w1200 t_center" v-if="!isMj">
      <ul class="clear t_center">
        <li><span class="f20 gray_3 icon0">名牌汇聚</span></li>
        <li><span class="f20 gray_3 icon1">优质优价</span></li>
        <li><span class="f20 gray_3 icon2">特级服务</span></li>
        <li><span class="f20 gray_3 icon3">正品保障</span></li>
      </ul>
      <div class="f_line"></div>
      <div class="box35"></div>
      <div class="f_codelie clear pad10_l">
        <div class="t_left float-left">
          <h2 class="f18">进货指南</h2>
          <ul>
            <li><a :href="`${app}goods/tofootindex/memberregistGuide.do`" class="f14 gray_3">用户注册</a></li>
            <li><a :href="`${app}goods/tofootindex/shoppingprocessGuide.do`" class="f14 gray_3">购物流程</a></li>
            <li><a :href="`${app}goods/tofootindex/commonproblemGuide.do`" class="f14 gray_3">常见问题</a></li>
          </ul>
        </div>
        <div class="t_left float-left">
          <h2 class="f18">支付方式</h2>
          <ul>
            <li><a :href="`${app}goods/tofootindex/payment1Type.do`" class="f14 gray_3">在线支付</a></li>
            <li><a :href="`${app}goods/tofootindex/payment2Type.do`" class="f14 gray_3">当面结算</a></li>
          </ul>
        </div>
        <div class="t_left float-left">
          <h2 class="f18">配送服务</h2>
          <ul>
            <li><a :href="`${app}goods/tofootindex/distribution1Service.do`" class="f14 gray_3">配送范围</a></li>
            <li><a :href="`${app}goods/tofootindex/distribution2Service.do`" class="f14 gray_3">自提服务</a></li>
          </ul>
        </div>
        <div class="t_left float-left">
          <h2 class="f18">售后保障</h2>
          <ul>
            <li><a :href="`${app}goods/tofootindex/returnPolicy.do`" class="f14 gray_3">退换政策</a></li>
          </ul>
        </div>
        <div class="t_left float-left">
          <h2 class="f18">商家合作</h2>
          <ul>
            <li><a :href="`${app}goods/tofootindex/processEnter.do`" class="f14 gray_3">商家入驻</a></li>
            <li><a :href="`${app}goods/tofootindex/basicRules.do`" class="f14 st gray_3">平台规则</a></li>
            <li><a :href="`${app}goods/tofootindex/feedStand.do`" class="f14 st gray_3">行业标准</a></li>
          </ul>
        </div>
        <div class="float-left pad70_l">
          <div class="float-left">
            <!--<img class="bor_e8" src="./images/codeimg0.jpg">-->
            <p class="f14 st gray_3 text-center">智农通客户端</p>
          </div>
          <div class="float-right pad70_l">
            <!--<img class="bor_e8" src="./codeimg1.jpg">-->
            <p class="f14 gray_3 t_center">农信商城微信</p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!isMj" class="box40"></div>
    <div class="coryright">
      <div class="w1200 t_center white">
        <div class="cor-link">
          <a :href="`${app}goods/tofootindex/aboutNxin.do`">关于农信商城</a>- <a :href="`${app}goods/tofootindex/contactUS.do`">联系我们</a>-
          <a :href="`${app}goods/tofootindex/qualification.do`">资质文件</a>- <a :href="`${app}mj/toSetbacks.do`">卖家中心</a>-
          <!--          <a :href="`${app}`">友情链接</a>-
          <a :href="`${app}`">法律声明</a>- -->
          <a :href="`${app}`">风险须知</a>
        </div>
        <!--        <div class="box5"></div>
        <div class="cor-link">
          <span>友情链接：</span>
          <a :href="`${app}`">国家生猪市场</a>-
          <a :href="`${app}`">农信互联</a>-
          <a :href="`${app}`">农博网</a>-
          <a :href="`${app}`">金色农华</a>-
          <a :href="`${app}`">绿色农华</a>-
          <a :href="`${app}`">福州生物</a>-
          <a :href="`${app}`">中国农民大学</a>-
          <a :href="`${app}`">大北农</a>
        </div>-->
        <!--        <p class="white">Copyright © 2013-2017 农信互联版权所有 营业执照91110108754681201W号 京ICP备13013445号</p>-->
        <a href="https://beian.miit.gov.cn/">浙ICP备17059353号</a>
        <p class="white">Copyright © 2017-2022 浙江农信数智电子商务有限公司版权所有</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isMj: true,
      app: process.env.VUE_APP_APP,
      passport: process.env.VUE_APP_PASSPORT,
    };
  },
};
</script>

<style scoped>
@import "./index.scss";
</style>
